import WorkoutVideoContent from "./WorkoutVideoContent";
import WorkoutExercisesContent from "./exercises/WorkoutExercisesContent";
import { useAppSelector } from "../../../../../../../../store/config";
import { notification, Spin } from "antd";
import { useTranslation } from "react-i18next";

export const WorkoutContent = () => {
  const { workout } = useAppSelector((state) => state.workout);
  const { t } = useTranslation();

  const [api, contextHolder] = notification.useNotification();

  const openNotification = (error?: string | null, isWarning?: boolean) => {
    api[isWarning ? "warning" : "error"]({
      message: t(error || "Something went wrong, please try again"),
      placement: "bottomLeft",
    });
  };

  return (
    <>
      {contextHolder}
      {!workout ? (
        <Spin></Spin>
      ) : workout.type === "video" ? (
        <WorkoutVideoContent openNotification={openNotification} />
      ) : (
        <WorkoutExercisesContent openNotification={openNotification} />
      )}
    </>
  );
};
